<header>
  <mat-toolbar
    class="bg-[var(--brand-gray-bg)] mat-elevation-z4 flex justify-between px-4 py-2 md:px-8 lg:px-12 xl:px-20 sticky top-0 z-50"
  >
    <div class="grid grid-cols-3 items-center w-full lg:flex lg:justify-start">
      <!-- Botón menú: visible solo en mobile -->
      <button
        mat-icon-button
        (click)="sidenav.toggle()"
        class="menu-button justify-self-start ml-2 xl:!hidden"
        aria-label="Abrir menú"
      >
        <svg
          viewBox="0 0 24 24"
          width="24"
          height="24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M3 6h18M3 12h18M3 18h18"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <!-- Logo -->
      <div class="flex justify-center lg:justify-start col-span-1">
        @if (!logo && !logoError) {
          <div
            class="w-[6.075rem] h-[4.536rem] rounded bg-gray-200 animate-pulse"
            aria-hidden="true"
          ></div>
        }
        @if (logo) {
          <div class="logo-wrapper" [routerLink]="['']">
            <div class="logo-crop">
              <img [src]="logo" alt="Soy iPhone" class="logo-img" />
            </div>
          </div>
        }
        @if (logoError) {
          <span
            [routerLink]="['']"
            class="text-lg font-semibold text-[var(--brand-indigo)] cursor-pointer"
            >Soy iPhone</span
          >
        }
      </div>

      <!-- Espacio vacío solo para mantener estructura en mobile -->
      <div class="md:hidden"></div>
    </div>

    <nav class="nav-links hidden xl:flex items-center gap-1 col-span-1">
      @for (hoja of hojas; track hoja) {
        <button
          class="nav-link"
          [routerLink]="urlSeccion(hoja)"
          routerLinkActive="active-link"
        >
          <span>{{ hoja }}</span>
        </button>
      }

      <button
        class="cta-secondary"
        [routerLink]="['/cotizar']"
        routerLinkActive="active-link-cta"
      >
        Plan Canje
      </button>

      <button
        class="nav-link"
        [routerLink]="['/preguntas-frecuentes']"
        routerLinkActive="active-link"
      >
        Información
      </button>

      <button
        class="nav-link"
        [routerLink]="['/reparacion-iphone-olavarria']"
        routerLinkActive="active-link"
      >
        Servicio técnico
      </button>

      @if (dolarBlueFormateado) {
        <div class="dolar-badge" title="Cotización del día">
          <i class="fas fa-money-bill-wave" aria-hidden="true"></i>
          <span>Cotización USD: ${{ dolarBlueFormateado }}</span>
        </div>
      }

      <button
        type="button"
        class="cta-primary"
        (click)="enviarWhatsApp()"
        aria-label="Consultar por WhatsApp"
      >
        <i class="fab fa-whatsapp" aria-hidden="true"></i>
        <span>WhatsApp</span>
      </button>
    </nav>
  </mat-toolbar>
</header>
